import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslate } from "@refinedev/core";
import type { BreadcrumbItem } from "@libertify/ui";

const HOME_PATH = "/home";

/** `@libertify/ui` Breadcrumb items for a page: "Home › current". */
export function useBreadcrumbItems(current: string): BreadcrumbItem[] {
  const t = useTranslate();

  return useMemo(
    () => [
      // Router link, so Ctrl/Cmd-click opens a new tab.
      { label: t("src.App.home"), as: Link, to: HOME_PATH },
      { label: current },
    ],
    [current, t]
  );
}
